import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";

import TurbineTable from "../components/WTG/table/turbineTable";
import { Box } from "@mui/system";
import { Grid, Typography } from "@mui/material";
import backgroundpicture from "../images/SCADA/oofShorePark.png"
import { AidEqipmentInfo } from "../components/WTG/EquipmentInfo";

var sectionStyle = {
  width: "100%",
  height: "400px",
  backgroundImage: 'url(${backgroundpicture })'
};


const green = '#00c853';
const yello = '#ffab00';
const red = '#dd2c00';
const backgroundColor="#455a64"
const PaperColor="#37474f";


const fakeTurbineData = {
  name: "WTF 1",
  lat: 49.1,
  long: 52.7,
  type: "IPS",
  equipment: {
    marineHelicopterCorridorLights: {
      state: 0,
      amount: "2",
      apiUrl: null,
      visible: true,
      status: true,
    },
    visibilitySensor: {
      state: 0,
      amount: "3",
      apiUrl: null,
      visible: true,
      status: true,
    },
    marineLanterns: {
      state: 0,
      amount: "4",
      apiUrl: null,
      visible: true,
      status: true,

    },
  }
  
}

const styles = {
  boxContainer: {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2),rgba(0, 0, 0, 0.3)), url(${backgroundpicture})`,
      backgroundSize: "100% 100vh",
      backgroundRepeat: "no-repeat"
  }
};

function WTG() {

  const turbineData = useSelector(
    (state) =>  state.turbine.turbineData
  );

  const [TurbineData, setTurbineData] = useState(fakeTurbineData);


  // useEffect(() => {
  //   if(turbineData!= null)
  //     setTurbineData(fakeTurbineData);
  //   else
  //     setTurbineData(fakeTurbineData)
  // }, [turbineData, TurbineData]);


  return (TurbineData ? <Box className="wrapper"
    // style={{ backgroundColor:backgroundColor }}
    style ={styles.boxContainer}

    >

      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-start"
      >
        <Grid item xs={4} marginTop={"20px"}>{AidEqipmentInfo(TurbineData.equipment)}</Grid>
        <Grid item xs={4}>

        </Grid>
        <Grid item xs={3.5} marginTop={"40px"}>
          <div >
            <TurbineTable WindTurbine={TurbineData} />
          </div>
        </Grid>
      </Grid>
    </Box>
    :   
    <Box className="wrapper"
    // style={{ backgroundColor:backgroundColor }}
    style ={styles.boxContainer}

    >
      <Typography variant="h5">
        Error
      </Typography>
      <Typography variant="h1">
        NO WTG IS SELECTED
      </Typography>
  </Box>

  ) 
}
export default WTG;
